import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { syncPending } from "@/lib/offline";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register Service Worker for offline exam support.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      // If a new SW takes over, reload once so users see the fresh bundle.
      let hasReloaded = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (hasReloaded) return;
        hasReloaded = true;
        window.location.reload();
      });
      // Nudge the new SW to activate immediately after install.
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) {
            // A new version is waiting — activation will fire controllerchange.
          }
        });
      });
    }).catch(() => {
      // best-effort — do not break app if SW fails to register
    });
  });
}

// When the browser regains connectivity, try to flush any pending submissions.
if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    syncPending().then((r) => {
      if (r.sent > 0) {
        window.dispatchEvent(new CustomEvent("canales:offline-synced", { detail: r }));
      }
    });
  });
}
